import { useCallback, useState } from 'react'

import { deleteOperator, getAllOperators } from '@/apis/operator'
import { CUSTOMER_TYPES } from '@/constants/customer'
import { DeleteIdCardRequest } from '@/types/apis/idCards'
import { GetAllOperatorsResponse } from '@/types/apis/operators/GetAllOperatorsResponse'

export const useOperators = () => {
  const [getOperatorsLoading, setGetOperatorsLoading] = useState(false)
  const [getOperatorsResponse, setOperatorsResponse] = useState<GetAllOperatorsResponse>()
  const [deleteOperatorLoading, setDeleteOperatorLoading] = useState(false)

  const get = useCallback(async () => {
    try {
      setGetOperatorsLoading(true)
      const res = await getAllOperators({ type: CUSTOMER_TYPES[1].id })

      setOperatorsResponse(res)
    } finally {
      setGetOperatorsLoading(false)
    }
  }, [])

  const del = useCallback(
    async ({ id }: DeleteIdCardRequest) => {
      try {
        setDeleteOperatorLoading(true)
        await deleteOperator({ id })

        if (getOperatorsResponse) {
          const newOperators = getOperatorsResponse.items.filter((item) => item.id !== id)
          setOperatorsResponse({ ...getOperatorsResponse, ...newOperators })
        }
      } finally {
        setDeleteOperatorLoading(false)
      }
    },
    [getOperatorsResponse]
  )

  return { getOperators: get, getOperatorsResponse, getOperatorsLoading, deleteOperator: del, deleteOperatorLoading }
}
